var _ellipse, _path, _path2, _ellipse2, _path3, _path4, _ellipse3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferencesOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2188,
    cy: 14.8125,
    rx: 2.40625,
    ry: 2.40625,
    stroke: "#3B9CB9",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 1.17676V12.4059",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 17.2188L18.2188 19.625",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.78125,
    cy: 14.8125,
    rx: 2.40625,
    ry: 2.40625,
    stroke: "#3B9CB9",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 1.17676V12.4059",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 17.2188L3.78125 19.625",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.40625,
    cy: 2.40625,
    rx: 2.40625,
    ry: 2.40625,
    transform: "matrix(1 0 0 -1 8.59375 8.39551)",
    stroke: "#3B9CB9",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.625V8.39583",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.58301L11 1.17676",
    stroke: "#3B9CB9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesOpen);
export default __webpack_public_path__ + "static/media/preferencesOpen.86929ff9cbfaa7172bc3f0a0bf7dfd9b.svg";
export { ForwardRef as ReactComponent };